// src/components/CreditsList.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import { api } from '../context/AuthContext'; // Removed unused useAuth
import api from '../api';

const CreditsList = () => {
  const [credits, setCredits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchCredits = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await api.get('/credits', {
          headers: { Authorization: `Bearer ${token}` }
        });
        setCredits(response.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Error fetching credits');
      } finally {
        setLoading(false);
      }
    };
    fetchCredits();
  }, []);

  if (loading) return <div className="container mt-4">Loading...</div>;
  if (error) return <div className="container mt-4 alert alert-danger">{error}</div>;

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Credit Management</h2>

      <div className="card shadow">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead className="table-dark">
                <tr>
                  <th>Date</th>
                  <th>Customer</th>
                  <th>Total Amount</th>
                  <th>Paid</th>
                  <th>Balance Remaining</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
              {credits.map((credit) => {
  const total = parseFloat(credit.totalAmount) || 0;
  const remaining = parseFloat(credit.remainingBalance) || 0;
  const paid = total - remaining;

  return (
    <tr key={credit._id}>
      <td>{new Date(credit.createdAt).toLocaleDateString()}</td>
      <td>{credit.customer}</td>
      <td>${total.toFixed(2)}</td>
      <td className="text-success">${paid.toFixed(2)}</td>
      <td className="text-danger">${remaining.toFixed(2)}</td>
      <td>
        <span className={`badge ${credit.status === 'paid' ? 'bg-success' : 'bg-warning'}`}>
          {credit.status}
        </span>
      </td>
      <td>
        <Link to={`/credits/${credit._id}`} className="btn btn-sm btn-primary">
          Manage
        </Link>
      </td>
    </tr>
  );
})}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditsList;
